import { serializePool } from './helpers'
import { SerializedPoolConfig } from './types'

const pools: SerializedPoolConfig[] = [].map(serializePool)

export default pools
